// extracted by mini-css-extract-plugin
module.exports = {"container":"claim_container__L5gqP","button":"claim_button__GyBsv"};